import { Directive, HostListener, Input } from '@angular/core';
@Directive({
  selector: '[smlNumericCustomChars]',
  standalone: true
})
export class NumericCustomCharsDirective {
  @Input() allowedChars = '';
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Escape', 'Enter'
    ];
    const customAllowedKeys = this.allowedChars.split('').filter(c => c.trim() !== '');
    const allAllowedKeys = [...allowedKeys, ...customAllowedKeys];
    if (allAllowedKeys.includes(event.key)) {
      return;
    }
    if (this.allowedChars === '' && !/^\d$/.test(event.key)) {
      event.preventDefault();
    }
    if (this.allowedChars !== '' && !/^\d$/.test(event.key) && !customAllowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
